// @flow
import React, { Component } from "react";
import classNames from "classnames";
import ErrorIcon from "@material-ui/icons/Error";
import WarningIcon from "@material-ui/icons/Warning";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../types/GeneralTypes";
import type { IconStylesClassesType } from "../styles/iconStyles";
import type { BannerStylesClassesType } from "../styles/generalStyles";
import { iconStyles } from "../styles/iconStyles";
import { bannerStyles } from "../styles/generalStyles";

export function setErrorMsg(
  errors: DictionaryType,
  errorType: string,
  errorMsg?: string
): DictionaryType {
  if (!errorMsg || errorMsg === "") {
    delete errors[errorType];
  } else {
    errors[errorType] = errorMsg;
  }
  return errors;
}

const styles = (theme: DictionaryType): DictionaryType => ({
  ...bannerStyles(theme),
  ...iconStyles(theme),
  rightMarigin: {
    marginRight: "5px"
  }
});

type ErrorDisplayClassesType = {
  ...IconStylesClassesType,
  ...BannerStylesClassesType,
  rightMarigin: DictionaryType
};

type ErrorDisplayPropsType = {
  classes: ErrorDisplayClassesType,
  errors: DictionaryType,
  isWarning?: boolean
};

class ErrorDisplay extends Component<ErrorDisplayPropsType, *> {
  render(): React$Element<*> | null {
    const { classes, errors } = this.props;

    let generalErrors = [];
    Object.keys(errors).forEach(function(key: string) {
      if (errors[key]) {
        generalErrors.push(
          <span key={"general_errors_" + key}>
            {errors[key]}
            <br />
          </span>
        );
      }
    });

    let Icon = ErrorIcon;
    if (this.props.isWarning) {
      Icon = WarningIcon;
    }

    if (Object.keys(errors).length > 0) {
      return (
        <div
          className={classNames(
            classes.banner,
            !this.props.isWarning && classes.error,
            this.props.isWarning && classes.warning
          )}
        >
          <div className={classes.box}>
            <Icon
              className={classNames(classes.inheritIcon, classes.rightMarigin)}
            />
            <span className={classes.content}>{generalErrors}</span>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

export default withStyles(styles)(ErrorDisplay);
